interface OrdersListKPIsProps {
    activeOrders: number
    processedPackages: number
    openContainers: number
    finishedOrders: number
}

const OrdersListKPIs = ({
    activeOrders,
    processedPackages,
    openContainers,
    finishedOrders,
}: OrdersListKPIsProps) => {
    return (
        <div className="flex items-center gap-[29px] p-4 bg-white border border-[#e2e8f0] rounded-xl w-full">
            <div className="flex flex-col gap-1 flex-1 min-w-0">
                <p className="text-sm font-normal leading-[18px] text-[#475569]">
                    Órdenes activas (hoy)
                </p>
                <p className="text-lg font-semibold leading-[1.2] text-[#568c13]">
                    {activeOrders}
                </p>
            </div>

            <div className="w-px self-stretch bg-[#cbd5e1]" />

            <div className="flex flex-col gap-1 flex-1 min-w-0">
                <p className="text-sm font-normal leading-[18px] text-[#475569]">
                    Paquetes procesados
                </p>
                <p className="text-lg font-semibold leading-[1.2] text-[#070a13]">
                    {processedPackages.toLocaleString()}
                </p>
            </div>

            <div className="w-px self-stretch bg-[#cbd5e1]" />

            <div className="flex flex-col flex-1 min-w-0">
                <p className="text-sm font-normal leading-[18px] text-[#475569]">
                    Contenedores abiertos
                </p>
                <p className="text-lg font-semibold leading-[1.2] text-[#070a13]">
                    {openContainers}
                </p>
            </div>

            <div className="w-px self-stretch bg-[#cbd5e1]" />

            <div className="flex flex-col flex-1 min-w-0">
                <p className="text-sm font-normal leading-[18px] text-[#475569]">
                    Órdenes finalizadas
                </p>
                <p className="text-lg font-semibold leading-[1.2] text-[#fdb022]">
                    {finishedOrders}
                </p>
            </div>
        </div>
    )
}

export default OrdersListKPIs
